import { useAtomValue } from 'jotai';
import { MDSButton, MDSDownloadPanel, MDSModal, MDSTypography } from '@marqvision/mds-v2';
import { useManagePanel, useRemoveTask } from './@hooks/useManagePanel';
import { usePollingTaskRunner, usePrepareTaskRunner } from './@hooks/useTaskRunner';
import { downloadPanelTaskStore, panelStatusAtom } from './@atoms';
import { useDownloadMonitoringPanel } from './@hooks';

export const Content = () => {
  const { panel, tasks, confirm } = useManagePanel();
  const { removeByTaskId } = useRemoveTask();
  return (
    <>
      <MDSDownloadPanel
        panel={{
          label: panel.panelLabel,
          isFold: panel.panelStatus.isFold,
          onToggleFold: panel.handleToggleFold,
          onClose: panel.handleClickClose,
        }}
        tasks={{
          list: tasks,
          onRemove: removeByTaskId,
        }}
      />

      <MDSModal.Wrapper isOpen={confirm.isOpen}>
        <MDSModal.Content>
          <MDSTypography variant="body" size="m" weight="medium">
            Are you sure you want to close this window? All exports in progress will be canceled.
          </MDSTypography>
        </MDSModal.Content>
        <MDSModal.Action>
          <MDSButton variant="border" size="medium" color="bluegray" onClick={confirm.continue}>
            Continue export
          </MDSButton>
          <MDSButton variant="fill" size="medium" color="red" onClick={confirm.terminate}>
            Cancel export
          </MDSButton>
        </MDSModal.Action>
      </MDSModal.Wrapper>
    </>
  );
};
const PrepareTaskRunner = () => {
  usePrepareTaskRunner();
  return null;
};
const PollingTaskRunner = () => {
  usePollingTaskRunner();
  return null;
};

const DownloadMonitoringPanelContent = () => {
  const panelStatus = useAtomValue(panelStatusAtom);

  return panelStatus.isOpen ? (
    <>
      <Content />
      <PollingTaskRunner />
      <PrepareTaskRunner />
    </>
  ) : null;
};

export type { Task, TaskWithResult } from './@types';
export {
  DownloadMonitoringPanelContent as Component,
  downloadPanelTaskStore as jotaiStore,
  useDownloadMonitoringPanel as useHook,
};
